import logo from './logo.svg';
import './App.css';
import Dashboard from './Dashboard';

function App() {
  return (
    <div className="">
      <Dashboard />
    </div>
  );
}

export default App;
